import { useState } from 'react'

import { DomainAmazon } from 'features/globalSetup/features/amazon/types/domainAmazon'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_DOMAIN_AMAZON_ALERTS } from './api/query'
import { Data, Variables } from './api/types'
import { Props, Return } from './types'

export const useGetDomainAmazonAlerts = ({ domainAmazonId }: Props): Return => {
  const [alerts, setAlerts] = useState<DomainAmazon['alerts']>([])

  useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node } = data

      if (node !== null) {
        setAlerts(fromDTO(node).alerts)
      }
    },
    query: GET_DOMAIN_AMAZON_ALERTS,
    variables: { id: domainAmazonId },
  })

  return { alerts }
}
